import theme from '@styles/theme';
export default {
  collectionContainer: {
    display: 'flex',
    flexDirection: 'column'
  },
  videoItemContainer: (index: number) => ({
    display: 'flex',
    flexDirection: ['column-reverse', 'column-reverse', 'column-reverse', 'column-reverse', `${index === 1 ? 'row-reverse' : 'row'}`],
    height: ['auto', 'auto', 'auto', 'auto', '420px'],
    marginTop: [0, 0, 0, 0, '40px']
  }),
  sliderVideo: (index: number) => ({
    height: ['212px', '432px', '432px', '432px', '100%'],
    width: ['100vw', '100vw', '100vw', '100vw', '50%'],
    padding: [0, 0, 0, 0, `${index % 2 === 0 ? '0 12px 0 0' : '0 0 0 12px'}`],
    marginLeft: ['-16px', '-16px', '-24px', '-24px', '0'],
    position: 'relative',
    video: {
      objectFit: 'cover'
    }
  }),
  descriptionContainer: {
    width: ['100%', '100%', '100%', '100%', '50%'],
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: ['40px', '40px', '40px', '40px', '0 155px']
  },
  collectionName: {
    margin: '0 0 40px'
  },
  description: (addMargin: boolean) => ({
    color: theme.rawColors.darkGrey700,
    marginBottom: `${addMargin ? '24px' : '0'}`,
    fontSize: theme.fontSizes.text,
    letterSpacing: theme.letterSpacings.caps,
    margin: ['0', '0 8px', '0 81px', '0 81px', '0 0 40px 0']
  }),
  link: {
    margin: ['40px auto 8px', '40px auto 8px', '40px auto 24px', '40px auto 24px', '40px auto 0']
  }
};